document.addEventListener('DOMContentLoaded', () => {

  /* --- 1. Global V3 Extreme Scroll Animations (Auto-Attach) --- */
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.05
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // V3: Select EVERYTHING that should pop in
  const selectorsToAnimate = [
    '.product-item',
    '.collection-card',
    '.promotion-block',
    '.shopify-section > .container > header',
    '.image-with-text__wrapper',
    '.article-item',
    '.footer__item',
    // Product Page Specifics to ensure absolute 1:1 animated feel
    '.product__info-container > *', // Every block in the product description area
    '.product-meta',
    '.product-form',
    '.product-gallery',
    '.trust-badge',
    '.shopify-app-block'
  ];

  const elementsToAnimate = document.querySelectorAll(selectorsToAnimate.join(', '));
  elementsToAnimate.forEach((el, index) => {
    // Avoid re-animating elements that are already handling their own visiblity if needed, but force most
    if(!el.classList.contains('global-animate')) {
        el.classList.add('global-animate');
        // Stagger them based on DOM order for a cascading waterfall effect
        const delayMs = (index % 8) * 0.1; 
        el.style.transitionDelay = `${delayMs}s`;
        observer.observe(el);
    }
  });


  /* --- 2. V3 Extreme 3-Step Shipping Timeline --- */
  window.updateShippingTimelineV3 = function(cartTotalCents) {
    const bars = document.querySelectorAll('.cart-timeline-progress-line');
    const steps = document.querySelectorAll('.cart-timeline-step');
    
    if(!bars.length || !steps.length) return;

    // Hardcoded logic for timeline steps based on user request:
    // Bestellt (Heute) -> Versendet (Morgen) -> Zugestellt (1-2 Tage)

    // For a cart that has ANY items, we assume it's "Bestellt" (Step 1 Complete)
    // and we highlight "Versendet" as the Next step
    let progressPercentage = 0;

    if (cartTotalCents > 0) {
      // Step 1 check
      steps.forEach(step => step.classList.remove('active', 'current'));
      
      // We animate the line to jump to the middle of the second step
      progressPercentage = 50; 

      // Activate Step 1
      if(steps[0]) steps[0].classList.add('active');
      
      // Make Step 2 Glow indicating it's the target "morgen"
      if(steps[1]) {
        steps[1].classList.add('active', 'current');
      }
    } else {
        // Empty Cart
        steps.forEach(step => step.classList.remove('active', 'current'));
        progressPercentage = 0;
    }
    
    bars.forEach(bar => {
      void bar.offsetWidth; // force reflow
      bar.style.width = progressPercentage + '%';
    });
  };

  // Attempt to listen to generic cart fetch requests to update dynamically alongside Shopify Cart JS
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];
    
    if (url && (typeof url === 'string') && (url.includes('/cart.js') || url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js'))) {
      const clonedResponse = response.clone();
      clonedResponse.json().then(data => {
        if (data && data.total_price !== undefined) {
          updateShippingTimelineV3(data.total_price);
        } else if (data && data.items) {
           originalFetch('/cart.js')
            .then(res => res.json())
            .then(cartData => updateShippingTimelineV3(cartData.total_price));
        }
      }).catch(e => console.error("Could not parse cart response", e));
    }
    return response;
  };

  // Initialize on load if there's a cart object rendered
  // (We check if cart form exists)
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
        if(cart && cart.total_price !== undefined) {
             updateShippingTimelineV3(cart.total_price);
        }
    });
});
